import React, { forwardRef } from 'react';

import classNames from 'classnames';
import { OverrideProps } from '../../../BaseComponent';
import { InputStatuses } from '../../../Input/types';
import { IBaseField } from '../../types';

interface WrapperFormFieldTypeMap<P = {}, D extends React.ElementType = 'div'> {
  props: P & {
    label?: React.ReactNode;
    status?: InputStatuses;
    afterLabel?: React.ReactNode;
    description?: IBaseField['description'];
    required?: boolean;
  };
  defaultComponent: D;
}

export type WrapperFormFieldProps<
  D extends React.ElementType = WrapperFormFieldTypeMap['defaultComponent'],
  P = {},
> = OverrideProps<WrapperFormFieldTypeMap<P, D>, D>;

interface WrapperFormFieldDefaultProps {
  component: React.ElementType;
}

const defaultProps: WrapperFormFieldDefaultProps = {
  component: 'div',
};

export const WrapperFormField = forwardRef(
  (_props: WrapperFormFieldProps, ref: any) => {
    const {
      component: Component,
      label,
      afterLabel,
      className,
      status,
      children,
      description,
      required,
    } = {
      ...defaultProps,
      ..._props,
    };

    return (
      <Component ref={ref}>
        {!!label && (
          <label className={classNames('form-label', required && 'required')}>
            {label}
            {description && (
              <span className="form-label-description">{description}</span>
            )}
          </label>
        )}
        <div>{children}</div>
      </Component>
    );
  },
);

WrapperFormField.displayName = 'WrapperFormField';
export default WrapperFormField;
